import { TemplateResult, html, CSSResultGroup } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../BlocksElement';
import type { LayoutContainerBehavior } from './layout-container.model';
import styles from './layout-container.styles';

/**
 * @slot default - The contents of the layout container
 * @csspart base - The component's base wrapper.
 * @csspart part-default - The component's default slot.
 */
export class BlocksLayoutContainer extends BlocksElement {static styles: CSSResultGroup = styles;

  /**
   * Behavior variants
   * <cat-text-passage size="sm">
   * <ul>
   *  <li>**`overflow-right-sm`** renders layout container that bleeds to the edge of the viewport</li>
   * on small screens
   * </ul>
   * </cat-text-passage>
   */
  @property({ type: String })
  behavior: LayoutContainerBehavior;

  /**
   * isFluid
   * It let container grow 100% to the width of the container
   */
  @property({ type: Boolean })
  isFluid = false;

  /**
   * Connected callback lifecycle
   */
  connectedCallback() {
    super.connectedCallback();
  }

  render(): TemplateResult<1> {
    const componentClassName = this.componentClassNames('cat-l-layout-container', {
      'cat-l-layout-container--overflow-right-sm': this.behavior === 'overflow-right-sm',
      'cat-l-layout-container--fluid': this.isFluid
    });

    return html`
      <div part="base" class="${componentClassName}">
        <slot part="part-default"></slot>
      </div>
    `;
  }
}

if (customElements.get('cat-layout-container') === undefined) {
  customElements.define('cat-layout-container', BlocksLayoutContainer);
}

declare global {
  interface HTMLElementTagNameMap {
    'cat-layout-container': BlocksLayoutContainer;
  }
}
